import { render, staticRenderFns } from "./batch-item.vue?vue&type=template&id=0b1b9ae0&"
import script from "./batch-item.vue?vue&type=script&lang=js&"
export * from "./batch-item.vue?vue&type=script&lang=js&"
import style0 from "./batch-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports